import React, { Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import { Button } from "@material-ui/core";
import ScheduleView from "../../widgets/ScheduleView";
import InsertMeetingWidget from "../../widgets/InsertMeetingWidget";
import EditMeetingWidget from "../../widgets/EditMeetingWidget";
import getCorso from "../../services/getCorso";
import getLezioni from "../../services/getLezioni";
import getChiusura from "../../services/getChiusura";
import getInsegnanti from "../../services/getInsegnanti";
import moment from "moment";
import Utils from "../../utils/utils";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import "moment/locale/it";
import deleteCalendar from "../../services/deleteCalendar";
import getMaterie from "../../services/getMaterie";
import SelectInput from "../../widgets/SelectInput";
import updateGiorniCorso from "../../services/updateGiorniCorso";
import GridSchedule from "../../widgets/GridSchedule";
import GridScheduleEnhanced from "../../widgets/GridScheduleEnhanced";

export default class Schedule extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.dataSourceCords = 0;
    this.ref = React.createRef();

    this.linkClicked = false;

    this.section = this.props.section;
    if (this.section == undefined) {
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    this.titlePage = "";

    this.timePrecision = 15;

    if (this.pageName == undefined) {
      this.pageName = this.section;
    }

    this.userslist = [];
    this.subjectName = "";
    this.eventDays = [];
    this.meetings = [];

    this.state = {
      testo: "",
      menuBackground: "#ffffff",
      menuItemColor: "#000000",
      fontSize: 50,
      fontBold: false,
      logoPicture: "",
      logoMargin: 0,
      titleColor: "#000000",
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      editorState: EditorState.createEmpty(),
      selectedDays: [],
    };

    this.grid = 2;

    this.pageTitle = "Calendario";

    this.state = {
      newEventParam: {
        visible: false,
      },
      editEventParam: {
        visible: false,
        meeting: undefined,
      },
      editBreakParam: {
        visible: false,
        break: undefined,
      },
    };
    this.weekdaysOptions = [
      { value: "Lun", label: "Lunedì" },
      { value: "Mar", label: "Martedì" },
      { value: "Mer", label: "Mercoledì" },
      { value: "Gio", label: "Giovedì" },
      { value: "Ven", label: "Venerdì" },
      { value: "Sab", label: "Sabato" },
      { value: "Dom", label: "Domenica" },
    ];
  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const scheduleType = cookies.get("scheduleType", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });
    this.brokerFlag = cookies.get("brokerFlag", { path: "/" });

    this.corso = await getCorso(username, token, currentCourse);

    // Debug: verifica caricamento corso
    console.log("Corso caricato:", this.corso);

    // Carica lezioni del corso corrente
    this.lezioni = await getLezioni(username, token);
    this.chiusura = await getChiusura(username, token);
    this.insegnanti = await getInsegnanti(username, token);
    this.materie = await getMaterie(username, token);

    // Filtra lezioni per il corso corrente
    this.lezioni = this.lezioni.filter((l) => {
      var altriCorsi = l.altri_corsi.split(";");
      return (
        l.id_corso == currentCourse || altriCorsi.indexOf(currentCourse) != -1
      );
    });

    this.meetings = this.lezioni.map((lezione) => {
      const insegnantiIds = lezione.id_insegnanti.split(",");

      const insegnanti = insegnantiIds
        .map((id) => this.insegnanti.find((i) => i.id == id.trim()))
        .filter((insegnante) => insegnante !== undefined);

      const insegnantiNomi = insegnanti
        .map((i) => i.nome + " " + i.cognome)
        .join(", ");

      return {
        id: lezione.id,
        data: lezione.data,
        durata: lezione.durata,
        insegnante: insegnantiNomi
          ? insegnantiNomi
          : "Insegnante non disponibile",
      };
    });

    this.scheduleType = scheduleType;
    this.scheduleSubject = currentCourse;
    this.savedEnabled = false;

    this.titlePage = "Calendario";
    this.subjectName = this.corso?.nome || this.corso?.name || "Corso";

    var startDate = this.corso.dateStart;
    var endDate = this.corso.dateEnd;

    startDate = moment(startDate, "yyyy-MM-DD");
    endDate = moment(endDate, "yyyy-MM-DD");

    this.courseDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate) {
      var chiusura = false;
      var weekEnd = false;
      this.chiusura.forEach((element) => {
        if (element.day == moment(tempDate).format("DD-MM-yyyy"))
          chiusura = true;
      });

      if (moment(tempDate).day() == 0 || moment(tempDate).day() == 6)
        weekEnd = true;

      if (chiusura == false) this.courseDays.push(moment(tempDate));

      tempDate = tempDate.add(1, "d");
    }

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 &&
      this.userslist.map((v, k) => {
        rows.push(createData(v.username, v.name, v.surname));
      });

    const giorniVisibili = this.corso.giorni_visibili || "";
    const giorniArray = giorniVisibili.split(",").map((g) => g.trim());
    const selectedDays = this.weekdaysOptions.filter((option) =>
      giorniArray.includes(option.value)
    );

    this.setState({
      selectedDays,
      editEventParam: {
        visible: false,
        meeting: undefined,
      },
    });
  }

  onContentStateChange = (contentState) => {
    this.savedEnabled = true;
    console.log("as HTML:", draftToHtml(contentState));
    this.setState({ contentState });
  };

  async componentDidMount() {
    this.reload();
  }

  handleDayChange = (selectedDays) => {
    const validSelectedDays = Array.isArray(selectedDays) ? selectedDays : [];

    this.setState({ selectedDays: validSelectedDays }, () => {
      if (validSelectedDays.length > 0) {
        this.saveDaysToDatabase(validSelectedDays);
      } else {
        this.saveDaysToDatabase([]);
      }
    });
  };

  saveDaysToDatabase = async (days = []) => {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    try {
      const selectedDaysString =
        days.length > 0 ? days.map((day) => day.value).join(",") : "";
      await updateGiorniCorso(
        username,
        token,
        currentCourse,
        selectedDaysString
      );
    } catch (error) {
      console.error("Errore nel salvataggio dei giorni:", error);
    }
  };

  hideEditWindow() {
    this.linkClicked = true;
    this.setState({ editEventParam: { visible: false } });
    this.setState({ editBreakParam: { visible: false } });
  }

  render() {
    if (!this.corso)
      return (
        <LoadingOverlay
          active={true}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Caricamento corso..."}
        >
          <div style={{ minHeight: "200px" }} />
        </LoadingOverlay>
      );

    const cookies = new Cookies();
    const currentCourse = cookies.get("currentCourse", { path: "/" });

    this.linkClicked = false;

    const selectedDays = this.state.selectedDays || [];

    const selectedDaysIndices = (selectedDays || [])
      .map((day) => {
        switch (day.value) {
          case "Lun":
            return 1;
          case "Mar":
            return 2;
          case "Mer":
            return 3;
          case "Gio":
            return 4;
          case "Ven":
            return 5;
          case "Sab":
            return 6;
          case "Dom":
            return 0;
          default:
            return null;
        }
      })
      .filter((index) => index !== null);

    const filteredCourseDays = this.courseDays.filter((day) =>
      selectedDaysIndices.includes(day.day())
    );

    return (
      <>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <div style={{ marginBottom: 20 }}>
            <PageTitle
              title={
                this.pageTitle +
                " " +
                (this.corso?.nome || this.corso?.name || "Caricamento...")
              }
              button="Elimina tutto"
              onClick={async () => {
                if (
                  !window.confirm(
                    "Vuoi davvero eliminare tutte le lezioni di questo calendario?"
                  )
                )
                  return;
                this.setState({ isLoading: true });
                const cookies = new Cookies();
                const username = cookies.get("username", { path: "/" });
                const token = cookies.get("token", { path: "/" });

                const res = await deleteCalendar(
                  username,
                  token,
                  currentCourse
                );
                if (res) {
                  alert("Lezioni eliminate con successo");
                  this.reload();
                  this.setState({ isLoading: false });
                  return;
                }

                this.setState({ isLoading: false });
                alert("Errore durante l'eliminazione delle lezioni");
              }}
            />
            <div style={{ display: "flex", gap: "10px", marginTop: 10 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  window.location.href = "/#/app/billing/editCorso/";
                }}
              >
                Piano Rateale
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  window.location.href = "/#/app/editCorso";
                }}
              >
                Modifica Corso
              </Button>
            </div>
          </div>

          {/* Grid del calendario */}
          <GridScheduleEnhanced
            breaks={this.breaks}
            parent={this}
            lezioni={this.lezioni}
            materie={this.materie}
            meeting={this.meetings}
            type={this.scheduleType}
            subject={currentCourse}
            insegnanti={this.insegnanti}
            corso={this.corso}
            onMouseClick={(date) => {
              if (this.linkClicked) return;

              let sameDayLesson = this.lezioni.find((m) => {
                const meetingDate = m.data.split(" ")[0];
                return meetingDate === date;
              });

              if (sameDayLesson) {
                this.setState({
                  editEventParam: {
                    visible: true,
                    meeting: sameDayLesson,
                  },
                });
                return;
              }

              this.setState({
                newEventParam: {
                  visible: true,
                  date: date,
                },
                anchor: date,
              });
            }}
          />

          {this.state.editEventParam.meeting && (
            <EditMeetingWidget
              key={Math.random()}
              visible={this.state.editEventParam.visible ? true : false}
              meeting={this.state.editEventParam.meeting}
              lezioni={this.lezioni}
              date={this.state.newEventParam.date}
              time={this.state.newEventParam.time}
              timePrecision={this.timePrecision}
              scheduleType={this.scheduleType}
              subjectName={this.subjectName}
              subjectId={currentCourse}
              corso={this.corso}
              investors={this.investors}
              companies={this.companies}
              onDone={() => {
                this.reload();
                this.setState({ editEventParam: { visible: false } });
              }}
            />
          )}

          <InsertMeetingWidget
            key={Math.random()}
            visible={this.state.newEventParam.visible ? true : false}
            date={this.state.newEventParam.date}
            time={this.state.newEventParam.time}
            meetings={this.meetings}
            aule={this.aule}
            scheduleType={this.scheduleType}
            timePrecision={this.timePrecision}
            subjectName={this.subjectName}
            subjectId={currentCourse}
            corso={this.corso}
            onDone={() => {
              this.reload();
              this.setState({ newEventParam: { visible: false } });
            }}
          />
        </LoadingOverlay>
      </>
    );
  }
}
